import { render } from "./regiesterComponent.vue?vue&type=template&id=09c3f8ce"
import script from "./regiesterComponent.vue?vue&type=script&lang=js"
export * from "./regiesterComponent.vue?vue&type=script&lang=js"

import "./regiesterComponent.vue?vue&type=style&index=0&id=09c3f8ce&lang=scss"

import exportComponent from "F:\\N\\nawaf\\nawaf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__